import { render, staticRenderFns } from "./DownloadImage.vue?vue&type=template&id=a98cf648&"
import script from "./DownloadImage.vue?vue&type=script&lang=js&"
export * from "./DownloadImage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports